<!--
 * Descripttion: 流程设计器
 * version: 1.0
 * Author: lybbn
 * Email: 1042594286@qq.com
 * Program: django-vue-lyadmin 专业版
 * Website: http://doc.lybbn.cn
 * gitee: https://gitee.com/lybbn/django-vue-lyadmin
 * Date: 2023-11-29
 * LastEditDate: 2023-11-29
 * Remark: 此文件头信息头信息需保留！！！
-->
<template>
    <div :class="{'ly-is-full-design':isFull}" style="height: 100%;overflow:none;">
        <el-container class="lyworkflowmain">
            <el-header class="lyworkflowheader" ref="lyworkflowheader" v-if="workflowConfig.showHeader">
                <div class="lyworkflowheader__title">
                    <span style="display: flex"><el-icon size="32px" color="#409eff"><Connection /></el-icon></span>
                    <span>lyWorkflow</span>
                    <span>流程设计器</span>
                    <span>Ver {{LYWORKFLOW_VERSION}}</span>
                </div>
                <div class="lyworkflowheader__dobutton">
                    <el-button type="primary" link @click="handleClick('delete')" v-if="workflowConfig.showClearButton">
                        <el-icon size="15px"><Delete/></el-icon>清空
                    </el-button>
                    <el-button type="primary" link @click="handleClick('importJson')" v-if="workflowConfig.importJsonButton">
                        <el-icon size="15px"><Upload/></el-icon>导入JSON
                    </el-button>
                    <el-button type="primary" link @click="handleClick('exportjson')" v-if="workflowConfig.exportJsonButton">
                        <el-icon size="15px"><Download/></el-icon>导出JSON
                    </el-button>
                    <el-button type="primary" link @click="handleClick('saveImg')" v-if="workflowConfig.showSaveImgButton">
                        <el-icon size="15px"><Picture/></el-icon>保存图片
                    </el-button>
                    <el-button type="primary" link @click="setFull" v-if="workflowConfig.showFullButton">
                        <el-icon size="15px"><full-screen/></el-icon>全屏
                    </el-button>
                    <el-button type="primary" link @click="handleClick('newtab')" v-if="workflowConfig.openNewWindowButton">
                        <el-icon size="15px"><ChromeFilled/></el-icon>新窗口打开
                    </el-button>
                    <el-button type="primary" link @click="handleClick('opendocment')" v-if="workflowConfig.showDocumentButton">
                        <el-icon size="15px"><Reading/></el-icon>文档
                    </el-button>
                    </div>
            </el-header>
            <el-container class="lyworkflow_design_container">
                <el-main class="lyworkflowdesign__main">
                    <lyworkflowDesign :isFull="isFull" v-model="flowConfig" ref="lyWrokflow" :isDesign="isDesign" :height="designHeight"></lyworkflowDesign>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script setup>
    import {ref, onMounted ,reactive,provide,watch,computed,nextTick} from 'vue'
    import lyworkflowDesign from '@/components/lyworkflow/lyworkflow-design/lyworkflowDesign'
    import {useRouter } from 'vue-router'
    import {LYWORKFLOW_VERSION} from "@/components/lyworkflow/config"
    import {getDefaultWorkflowConfig} from "@/utils/util"
    import { ElMessage } from 'element-plus'

    const props = defineProps({
        modelValue: { //prop传入的流程配置
            type: Object,
            default: () => getDefaultWorkflowConfig()
        },
        isDesign: { //是否设计模式
            type: Boolean,
            default: true
        },
        height:{ type:String, default:"auto" },//流程设计器高度，auto自动，其他如500px固定高度
        workflowConfig :{
            type:Object,
            default:{
                showHeader:true,//是否显示头部信息
                showClearButton:true,//是否显示清空按钮
                showDocumentButton:true,//是否显示文档按钮
                exportJsonButton: true,  //是否显示导出JSON器按钮
                importJsonButton:true, //是否显示导入代码按钮
                showFullButton: true,  //是否显示全屏按钮
                openNewWindowButton: true,  //是否显示新窗口按钮
                showSaveImgButton:true,//是否显示保存图片按钮
            }
        },
    })
    watch(()=>props.height,(newVal, oldVal)=>{
        calcScrollerHeight()
    })
    let lyworkflowheader = ref(null)
    let lyWrokflow = ref(null)

    const emits = defineEmits(['update:modelValue'])

    let designHeight = ref("auto")
    function calcScrollerHeight(){
        if(props.height != "auto"){
            nextTick(()=>{
                // const headerheight= lyworkflowheader.value?lyworkflowheader.value.$el.offsetHeight:0
                let headerheight = 49
                if(!props.workflowConfig.showHeader){
                    headerheight = 0
                }
                const tempheight = (parseInt(props.height) - headerheight)+'px'
                designHeight.value=tempheight
            })
            
        }else{
            designHeight.value = "auto"
        }
    }

    const flowConfig = computed({
        get() {
            return props.modelValue
        },
        set(value) {
            emits('update:modelValue', value)
        }
    })

    const router = useRouter()

    const isFull = ref(false)

    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }

    function handleClick(flag) {
        if(flag==="opendocment"){
            window.open("https://doc.lybbn.cn")
        }else if(flag==="exportjson"){
            lyWrokflow.value.exportJsonCode()
        }else if(flag==="importJson"){
            lyWrokflow.value.importJsonCode()
        }else if(flag==="delete"){
            lyWrokflow.value.clearFlowConfig()
        }else if(flag==="saveImg"){
            ElMessage.success("正在导出图片...")
            lyWrokflow.value.saveAsImg()
        }
        else if(flag==="newtab"){
            let currentPath = router.currentRoute.value.path
            let routeData = router.resolve({path:currentPath})
            window.open(routeData.href,'_blank')
        }
    }

    defineExpose({
        setFull
    })

</script>

<style scoped>
    .lyworkflowheader{
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: var(--l-changetab-bg);
        height: 48px;
        line-height: 48px;
        border-bottom: 2px dotted var(--l-lyformbuilder-border-color);
    }
    .lyworkflowheader__title{
        font-size: 18px;
        color: var(--l-lyformbuilder-font-color);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .lyworkflowheader__title span:nth-child(2){
        font-weight: bold;
        font-size: 20px;
        margin: 0 6px 0 6px;
    }
    .lyworkflowheader__title span:last-child{
        font-size: 14px;
        margin-left: 6px;
    }
    .lyworkflowheader__dobutton{
        display: flex;
        align-items: center;
        font-size: 13px;
    }
    .lyworkflowdesign__main{
        background: var(--l-changetab-bg);
    }
    .el-container{
        height: 100%;
    }
    .lyworkflow_design_container{
        /* height: calc(100% - 48px); */
    }
</style>